import { render, staticRenderFns } from "./icon-facebook.vue?vue&type=template&id=002235f4&scoped=true&"
import script from "./icon-facebook.vue?vue&type=script&lang=js&"
export * from "./icon-facebook.vue?vue&type=script&lang=js&"
import style0 from "./icon-facebook.vue?vue&type=style&index=0&id=002235f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002235f4",
  null
  
)

export default component.exports